<mat-card class="height-100">
  <mat-card-header>
    <mat-card-title>
      Adicionar supervisor
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Dados" style="flex: 1;">
        <ng-template mat-tab-label>
          Dados
          <i
            *ngIf="formDadosValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <div class="flex width-100">
          <div class="flex-column mt-2 col-md-4">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>CPF/CNPJ</mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('cpf_cnpj')"
                mask="000.000.000-00||00.000.000/0000-00"
                (blur)="checkCpfCnpj()"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('repeated')
              "
            >
              Informação já cadastrada
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('mask')
              "
            >
              Valor inválido
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('required')
              "
            >
              O CPF/CNPJ é obrigatório
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('pattern')
              "
            >
              Este CPF/CNPJ é inválido
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('maxlength')
              "
            >
              O CPF/CNPJ deve conter no máximo 14 caracteres
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('duplicate')
              "
            >
              O CPF/CNPJ já esta cadastrado
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCPF')
              "
            >
              Este CPF é inválido
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCNPJ')
              "
            >
              Este CNPJ é inválido
            </small>
          </div>
          <div class="flex-column mt-2 col-md-8">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Nome</mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('nome_razao_social')"
                required
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('nome_razao_social').touched &&
                form.get('nome_razao_social').hasError('required')
              "
            >
              O nome é requerido
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('nome_razao_social').touched &&
                form.get('nome_razao_social').hasError('maxlength')
              "
            >
              O nome deve ter no maximo 60 caracteres
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('nome_razao_social').touched &&
                form.get('nome_razao_social').hasError('isEmptyValue')
              "
            >
              Valor inválido: remova os espaços!
            </small>
          </div>
        </div>
        <div class="flex width-100">
          <div class="flex-column mt-2 col-md-6">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Apelido</mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('apelido_nome_fantasia')"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('apelido_nome_fantasia').touched &&
                form.get('apelido_nome_fantasia').hasError('maxlength')
              "
            >
              Este nome é muito longo
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('apelido_nome_fantasia').touched &&
                form.get('apelido_nome_fantasia').hasError('minlength')
              "
            >
              Este nome é muito curto
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('apelido_nome_fantasia').touched &&
                form.get('apelido_nome_fantasia').hasError('isEmptyValue')
              "
            >
              Valor inválido: remova os espaços!
            </small>
          </div>
          <div class="flex-column mt-2 col-md-6">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>RG</mat-label>
              <input
                matInput
                type="text"
                (keydown)="notText($event)"
                (blur)="checkRgInscEstadual()"
                [formControl]="form.get('rg_insc_est')"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('rg_insc_est').touched &&
                form.get('rg_insc_est').hasError('maxlength')
              "
            >
              O campo deve conter no máximo 20 caracteres
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('rg_insc_est').touched &&
                form.get('rg_insc_est').hasError('pattern')
              "
            >
              Este valor é inválido
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('rg_insc_est').touched &&
                form.get('rg_insc_est').hasError('isEmptyValue')
              "
            >
              Valor inválido: remova os espaços!
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('rg_insc_est').touched &&
                form.get('rg_insc_est').hasError('existSpecialChar')
              "
            >
              Valor inválido: não aceita pontuação!
            </small>
          </div>
        </div>
        <div class="flex width-100">
          <div class="flex-column mt-2 col-md-6">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Data de nascimento</mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('data_nascimento')"
                [matDatepicker]="picker"
                fastFormatData
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('data_nascimento').hasError('matDatepickerParse') &&
                this.form.get('data_nascimento').touched
              "
            >
              Esta data é invalida.
            </small>
            <small
              class="p-error"
              id="error-data-nascimento"
              *ngIf="form.get('data_nascimento').hasError('invalidDate')"
            >
              Data não pode ser posterior a atual
            </small>
          </div>
          <div class="mt-2 col-md-6">
            <autocomplete-users
              #input
              [autoFirst]="false"
              required
              [notShowResultsFirst]="false"
              [control]="form.get('user')"
              (clearSelection)="form.get('user').reset()"
              [user_id]="user_id"
              placeholder="Usuário"
              [domain_id]="tokenService.getDomain().id"
              aria-autocomplete="off"
              displayField="name"
              [messages]="{
                typeIs: 'Informe um valor válido',
                isEmptyValue: 'Valor inválido: remova os espaços!'
              }"
              [pageValue]="'0'"
              [pageSizeValue]="'10'"
            ></autocomplete-users>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Endereço" style="flex: 1;">
        <ng-template mat-tab-label>
          Endereço
          <i
            *ngIf="formAddressValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <app-fast-endereco [entity]="entity.parceiro"></app-fast-endereco>
      </mat-tab>
      <mat-tab label="Contatos">
        <app-fast-contato [entity]="entity.parceiro"></app-fast-contato>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
  <mat-card-actions>
    <div class="row m-0 pb-2">
      <div class="mt-2 col-md-12" style="display: flex; justify-content: flex-end;">
        <button mat-stroked-button color="warn" [matDialogClose]="undefined">
          Cancelar
        </button>
        <button
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="!formValid"
        >
          Cadastrar
        </button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
